import React from 'react';
import { ADVISORS, getLocalizedAdvisor } from '../../data/advisors';
import { GraduationCap, BookOpen } from 'lucide-react';
import { useTranslation } from '../../i18n';

export const AdvisorSelection = ({ selectedAdvisor, onSelect }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4" data-testid="step-advisor">
      <h2 className="text-xl font-bold text-slate-100">{t('choose_guide')}</h2>
      <p className="text-sm text-slate-500">
        {t('advisor_intro')}
      </p>

      <div className="space-y-3">
        {Object.values(ADVISORS).map(rawAdvisor => {
          const advisor = getLocalizedAdvisor(rawAdvisor.id);
          const isSelected = selectedAdvisor === advisor.id;
          const Icon = advisor.id === 'maurice' ? GraduationCap : BookOpen;

          return (
            <button
              key={advisor.id}
              onClick={() => onSelect(advisor.id)}
              className={`w-full text-left rounded-xl border-2 transition-all overflow-hidden ${
                isSelected
                  ? `${advisor.borderColor} shadow-lg`
                  : 'border-ink-600 hover:border-ink-500 '
              }`}
              data-testid={`advisor-card-${advisor.id}`}
            >
              <div className="flex gap-4 p-4">
                {/* Portrait */}
                <div className={`w-24 h-28 rounded-lg overflow-hidden flex-shrink-0 border-2 ${
                  isSelected ? advisor.borderColor : 'border-ink-600'
                }`}>
                  <img
                    src={advisor.portrait}
                    alt={advisor.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <div className={`p-1.5 rounded-lg ${isSelected ? 'bg-ink-800/80' : 'bg-ink-700/40'}`}
                      style={isSelected ? { backgroundColor: advisor.accentColor + '20' } : {}}
                    >
                      <Icon className="w-4 h-4" style={isSelected ? { color: advisor.accentColor } : { color: '#6B7280' }} />
                    </div>
                    <div>
                      <p className={`font-bold text-sm ${isSelected ? advisor.textColor : 'text-slate-100'}`}>
                        {advisor.name}
                      </p>
                      <p className="text-[10px] text-slate-500">{advisor.title} — {advisor.age} {t('years_old')}</p>
                    </div>
                  </div>

                  <p className="text-xs text-slate-400 leading-relaxed mt-1.5">
                    {advisor.description}
                  </p>

                  <p className="text-[11px] mt-2 font-medium italic" style={{ color: advisor.accentColor }}>
                    "{advisor.personality}"
                  </p>
                </div>
              </div>

              {isSelected && (
                <div className="px-4 py-2 text-center text-xs font-semibold text-foreground"
                  style={{ backgroundColor: advisor.accentColor }}
                >
                  {t('guide_selected')}
                </div>
              )}
            </button>
          );
        })}
      </div>

      <p className="text-[10px] text-slate-500 text-center mt-2">
        {t('advisor_disable_hint')}
      </p>
    </div>
  );
};

export default AdvisorSelection;
